import { render, staticRenderFns } from "./TermsAndConditionsV2.vue?vue&type=template&id=ca50cfe6&"
var script = {}
import style0 from "./TermsAndConditionsV2.vue?vue&type=style&index=0&id=ca50cfe6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports